import { Typography } from "@spz/ui/components/typography";
import { cn } from "@spz/ui/lib/utils";
import { useTranslation } from "react-i18next";
import SpzLogo from "../../../assets/logo-spz-white.svg";

interface OnboardingSpzBannerProps {
  className?: string;
}

export const OnboardingSpzBanner = ({
  className,
}: OnboardingSpzBannerProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "flex items-center justify-center flex-col h-full",
        "p-8 lg:p-[16%] xl:p-16",
        "text-white",
        className,
      )}
    >
      {/* Main Content Container */}
      <div className="flex flex-col items-center justify-center flex-grow max-w-2xl">
        {/* Logo and Content Row */}
        <div className="flex flex-col items-start gap-8 w-full">
          {/* Logo Section */}
          <div>
            <img src={SpzLogo} alt="Supervizor Logo" className="w-[175px]" />
          </div>

          {/* Content Section */}
          <div className="flex flex-col space-y-8">
            <div className="space-y-6 max-w-xl">
              <Typography variant="h3">{t("spz_banner_title")}</Typography>
              <Typography>{t("spz_banner_description")}</Typography>
            </div>
            <Typography variant="caption">
              {t("spz_banner_footer_text")}
            </Typography>
          </div>
        </div>
      </div>

      {/* Footer Section */}
      <div className="self-end">
        <Typography variant="caption">www.supervizor.com</Typography>
      </div>
    </div>
  );
};
